export function getRoute(user, path) {
  if (!user || !user.role) return `/login`;

  switch (user.role) {
    case "admin":
      return `/${path}`;
    case "user":
      return `/users/${path}`;
    case "oper":
      return `/oper/${path}`;
    case "tec":
      return `/tec/${path}`;
    default:
      return `/${path}`;
  }
}
